import * as React from "react";

import { Dialog, Typography, Stack, Box } from "@mui/material";

export const CustomDialogTemplate = (props) => {
  const {
    open,
    handleClose,
    content = null,
    PaperProps,
    title,
    isHeader = true,
    tableFooter,
    handleBack,
    isBackArroaw,
    middleContent,
  } = props;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={PaperProps}
      sx={{
        maxHeight: "100%",
        "& + .pac-container": {
          zIndex: 18000,
        },
      }}
    >
      {isHeader && (
        <>
          <Stack
            direction="row"
            justifyContent="space-between"
            position="sticky"
            zIndex={999}
            bgcolor="#fff"
            top={0}
          >
            <Stack
              direction="row"
              alignItems="center"
              sx={{ padding: "12px", gap: "14px" }}
              flex={1}
            >
              {isBackArroaw ? (
                <img
                  alt="edit"
                  onClick={() => handleBack()}
                  src="/icons/ic_back.png"
                  style={{ cursor: "pointer" }}
                />
              ) : (
                ""
              )}
              {typeof title === "string" ? (
                <Typography fontWeight={500} fontSize="16px">
                  {title}
                </Typography>
              ) : (
                title
              )}
            </Stack>
          </Stack>
          {middleContent ? middleContent : ""}
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              bgcolor: "#fff",
            }}
          />
        </>
      )}

      {content}

      {tableFooter && (
        <Stack
          justifyContent="space-between"
          position="sticky"
          zIndex={999}
          backgroundColor="background.paper"
          bottom={0}
          marginTop="auto"
          sx={{
            boxShadow: "0px -2px 6px rgba(0, 0, 0, 0.1)", // Soft top shadow effect
            padding: "6px",
          }}
        >
          {tableFooter}
        </Stack>
      )}
    </Dialog>
  );
};
